/* unplugin-vue-components disabled */import { render } from "./create_order.vue?vue&type=template&id=27bc6734&scoped=true"
import script from "./create_order.vue?vue&type=script&lang=js"
export * from "./create_order.vue?vue&type=script&lang=js"

import "./create_order.vue?vue&type=style&index=0&id=27bc6734&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27bc6734"]])

export default __exports__